import {Colors} from '~/common/fabric/Card/components/Colors/Colors';
import {Icons} from '~/common/fabric/Card/components/Icons/Icons';
import {useBackground} from '~/common/fabric/CreateDesign/components/Background/actions/useBackground';
import {MobileBox} from '~/common/fabric/CreateDesign/components/Background/Mobile/Contents/MobileBox';
import {EditorContainer} from '~/common/fabric/CreateDesign/components/Container/Mobile/EditorContainer';
import {mobileColors} from '~/common/fabric/CreateDesign/constants';
import {Typography} from '~library/atoms/Typography';
import {SparkleIcon} from '~library/svg/SparkleIcon';

export const BackgroundEditorMobile = () => {
  const {backgroundIcons, onColorChange, onTextureChange, selectedBackground} = useBackground(true);

  return (
    <EditorContainer>
      <div className="mobile-box">
        <div className="background-editor__header">
          <Typography as="h1" variant="paragraph4" size="medium" color="pebble">
            Backgrounds
          </Typography>
          <div className="background-editor__header--animated">
            <SparkleIcon ratio={0.75} className="background-editor__svg" />
            <Typography as="h1" variant="paragraph4" size="medium" color="tanzanite">
              Animated
            </Typography>
          </div>
        </div>
        <Icons
          icons={backgroundIcons}
          onClick={onTextureChange}
          selectedIcon={selectedBackground?.icon}
          highlight={false}
          square
          height={40}
          width={40}
          mobile
        />
      </div>
      <MobileBox title="Solid Colors">
        <Colors
          colors={mobileColors}
          onClick={onColorChange}
          highlight={false}
          height={40}
          width={40}
          mobile
        />
      </MobileBox>
    </EditorContainer>
  );
};
